<template>
  <div>
    <span v-if="uploading">{{$t('im.upload.uploadingImg')}}</span>
    <div :id="quillId" :style="{'height': height+'px'}"></div>
    <!-- 自定义上传图片功能 (使用element upload组件) -->
    <el-upload :action="uploadUrl" :headers="uploadHeaders" :show-file-list="false" :before-upload="uploadBeforeUploadHandle" :on-success="uploadSuccessHandle" style="display: none;">
      <el-button ref="uploadBtn" type="primary" size="small">{{$t('im.bt.upload')}}</el-button>
    </el-upload>
  </div>
</template>

<script>
  import 'quill/dist/quill.snow.css'
  import Quill from 'quill'
  import { getToken } from '@/utils/auth'
  import { localRead, getQueryString } from '@/utils/tools'

  export default {
    name: 'quill',
    props: {
      uploadUrl: false,
      quillId: {
        type: String,
      },
      height: {
        type: Number,
      }
    },
    data() {
      return {
        uploadHeaders: {},
        quillEditor: null,
        quillEditorToolbarOptions: [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block', 'image'],
          [{ header: 1 }, { header: 2 }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }],
          [{ indent: '-1' }, { indent: '+1' }],
          [{ direction: 'rtl' }],
          [{ size: ['small', false, 'large', 'huge'] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
          [{ font: [] }],
          [{ align: [] }],
          ['clean']
        ],
        uploading: false
      }
    },
    methods: {
      init(html) {
        this.$nextTick(() => {
          if (this.quillEditor) {
            this.quillEditor.deleteText(0, this.quillEditor.getLength())
          } else {
            this.quillEditorHandle()
          }
          if (html != null && html != '') this.quillEditor.root.innerHTML = html
        })
      },
      text(html) {
        if (this.quillEditor) {
          this.$set(this.quillEditor.root, 'innerHTML', html)
        }
      },
      // 富文本编辑器
      quillEditorHandle() {
        this.quillEditor = new Quill('#' + this.quillId, {
          modules: {
            toolbar: this.quillEditorToolbarOptions
          },
          theme: 'snow'
        })
        // 自定义上传图片功能 (使用element upload组件)
        this.quillEditor.getModule('toolbar').addHandler('image', () => {
          this.$refs.uploadBtn.$el.click()
        })
        // 监听内容变化，动态赋值
        this.quillEditor.on('text-change', () => {
          //this.textchange(this.quillEditor.root.innerHTML);
        })
      },
      getHtml() {
        if (this.quillEditor.root.innerHTML == '<p><br></p>') this.quillEditor.root.innerHTML = null
        return this.quillEditor.root.innerHTML
      },
      // 上传图片之前
      uploadBeforeUploadHandle(file) {
        if (
          file.type !== 'image/jpg' &&
          file.type !== 'image/jpeg' &&
          file.type !== 'image/png' &&
          file.type !== 'image/gif'
        ) {
          this.$message.error(window.$t('im.upload.uploadImgTip'))
          return false
        }
        this.uploading = true
      },
      // 上传图片成功
      uploadSuccessHandle(res, file, fileList) {
        this.uploading = false
        if (res.code != 0) {
          return this.$message.error(res.msg)
        }
        this.quillEditor.insertEmbed(
          this.quillEditor.getSelection().index,
          'image',
          res.result
        )
      }
    },
    mounted() {
      if (localRead('sysToken')) {
        this.uploadHeaders.Authorization = localRead('sysToken')
      } else if (window.SITE_CONFIG['routerLabel']) {
        this.uploadHeaders.Authorization = getToken(window.SITE_CONFIG['routerLabel'])
      } else if (window.location.href.indexOf('label') != -1) {
        let labelRouter = getQueryString('label')
        this.uploadHeaders.Authorization = getToken(labelRouter)
      }
    },
  }
</script>
